// src/components/chatPolicy/PrivilegeCard.jsx
// Edita el doc singleton de privilegios universales.
import React, { useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import MultiSelectChips from './MultiSelectChips';
import UserTypeahead   from './UserTypeahead';
import { getPrivilege, updatePrivilege } from '../../services/chatPolicyApi';

export default function PrivilegeCard({ catalog }) {
    const [doc, setDoc] = useState(null);
    const [puestos, setPuestos] = useState([]);
    const [users, setUsers]     = useState([]);
    const [saving, setSaving]   = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPrivilege()
            .then(d => {
                setDoc(d);
                setPuestos(d.puestos || []);
                setUsers(d.users || []);
            })
            .catch(() => toast.error('No se pudo cargar privilegios'))
            .finally(() => setLoading(false));
    }, []);

    const save = async () => {
        setSaving(true);
        try {
            const updated = await updatePrivilege({
                puestos,
                users: users.map(u => u._id),
            });
            setDoc(updated);
            toast.success('Privilegios actualizados');
        } catch (e) {
            toast.error(e.response?.data?.error || 'No se pudo guardar');
        } finally { setSaving(false); }
    };

    if (loading) return <div style={{ textAlign: 'center', padding: 24 }}><Spinner size="sm" animation="border" /></div>;

    return (
        <div style={{ background: 'var(--c-card)', border: '1px solid var(--c-border)', borderRadius: 12, padding: 16 }}>
            <h5 style={{ fontWeight: 700, marginBottom: 4 }}>Privilegios universales</h5>
            <p style={{ fontSize: 12, color: 'var(--c-text-4)', marginBottom: 14 }}>
                Quienes estén aquí pueden iniciar chat con <strong>cualquier persona</strong>, sin importar
                departamento ni protecciones. Pensado para directores y subdirectores.
            </p>

            <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: 'block' }}>Puestos</label>
                <MultiSelectChips
                    options={catalog?.puestos || []}
                    value={puestos}
                    onChange={setPuestos}
                    placeholder="Buscar puesto…"
                />
            </div>

            <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: 'block' }}>Usuarios específicos</label>
                <UserTypeahead value={users} onChange={setUsers} placeholder="Buscar usuario…" catalog={catalog} />
            </div>

            <div style={{ textAlign: 'right' }}>
                <Button size="sm" variant="success" onClick={save} disabled={saving}>
                    {saving ? 'Guardando…' : 'Guardar privilegios'}
                </Button>
            </div>
        </div>
    );
}
